import { head, reduce, isEmpty } from 'lodash';
import { scaleLinear, select, event } from 'd3';
import helper from './helper';
import drops from './drops';
import dropLine from './dropLine';
import barLine from './barLine';
import marker from './marker';
import zoom from './zoom';

export default (mouseEvents, containerWidth) => (selection) => {
  const data = head(selection.data());
  const { destinations } = data;
  const { hidePopover } = mouseEvents;
  const totalDistance = reduce(destinations, (total, destination) => {
    const distance = !isEmpty(destination.direction) ? destination.direction.distance : 0;
    return total + distance;
  }, 0);

  const displayTranslate = {
    dx: 140,
    dy: containerWidth - 20,
  };
  const { onLinkClick } = mouseEvents;
  const xScale = scaleLinear()
    .domain([0, totalDistance])
    .range([displayTranslate.dx, displayTranslate.dy]);

  const gProgress = selection.selectAll('.progress').data(d => Array(d));
  const progress = gProgress
    .enter()
    .append('g')
    .classed('progress', true);

  progress
    .append('rect')
    .attr('fill', '#f0f3f5')
    .attr('width', containerWidth - 123)
    .attr('height', 80)
    .attr('y', 0)
    .attr('x', 120)
    .on('click', () => {
      event.stopPropagation();
      hidePopover();
    })
    .style('stroke', '#ccc')
    .style('stroke-width', 1);

  const draw = (scale, mEvents) => (sel) => {
    sel
      .call(dropLine(scale, totalDistance))
      .call(barLine(scale))
      .call(drops(scale, mEvents))
      .call(marker(scale, mEvents));
  };

  progress
    .call(draw(xScale, mouseEvents))
    .call(zoom(xScale, draw, mouseEvents, displayTranslate));

  const gPercentage = selection.selectAll('.percentage').data(d => Array(d));
  const percentage = gPercentage
    .enter()
    .append('g')
    .classed('percentage', true);

  percentage
    .append('rect')
    .attr('fill', '#29363D')
    .attr('height', 80)
    .attr('width', 120)
    .attr('y', 0)
    .attr('x', 2);

  const tPercent = percentage
    .append('text')
    .attr('transform', 'translate(60)')
    .attr('y', 30)
    .style('font-weight', 'bold')
    .style('font-family', 'open sans,tahoma,sans-serif')
    .style('fill', '#F0F3F5');

  tPercent
    .append('tspan')
    .attr('x', 0)
    .style('font-size', '25')
    .attr('text-anchor', 'middle')
    .text(d => `${d.total_percentage}%`);

  const tNumber = percentage
    .append('text')
    .on('click', onLinkClick('number'))
    .on('mouseover', function onHover() {
      select(this).style('text-decoration', 'underline');
    })
    .on('mouseout', function onUnhover() {
      select(this).style('text-decoration', 'unset');
    })
    .attr('transform', 'translate(60)')
    .attr('y', 50)
    .style('cursor', 'pointer')
    .style('font-family', 'open sans,tahoma,sans-serif')
    .style('fill', '#F0F3F5');

  tNumber
    .append('tspan')
    .attr('x', 0)
    .style('font-size', '14')
    .attr('text-anchor', 'middle')
    .text(d => `${d.number}`);

  const tDriver = percentage
    .append('text')
    .on('click', onLinkClick('driver'))
    .on('mouseover', function onHover() {
      select(this).style('text-decoration', 'underline');
    })
    .on('mouseout', function onUnhover() {
      select(this).style('text-decoration', 'unset');
    })
    .attr('transform', 'translate(60)')
    .attr('y', 70)
    .style('cursor', 'pointer')
    .style('font-family', 'open sans,tahoma,sans-serif')
    .style('fill', '#F0F3F5');

  tDriver
    .append('tspan')
    .attr('x', 0)
    .style('font-size', '14')
    .attr('text-anchor', 'middle')
    .text(d => `${helper.get(d, 'driver.name')}`);
};



// WEBPACK FOOTER //
// ./src/components/dashboard_widgets/shipment_completion/draw.js